export const perPage = 20;
export const regionNames = new Intl.DisplayNames(["en"], { type: "region" });